var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FeaturedDataElementGridItem, FlexColumnCenter } from "./subcomponents";
import DataElement from "../DataElement";
var FeaturedDataElement = function (_a) {
    var additionalLabel = _a.additionalLabel, dataCy = _a.dataCy, isLargerText = _a.isLargerText, label = _a.label, toolTipText = _a.toolTipText, type = _a.type, value = _a.value;
    return (_jsx(FeaturedDataElementGridItem, __assign({ item: true }, { children: _jsx(FlexColumnCenter, { children: _jsx(DataElement, { additionalLabel: additionalLabel, dataCy: dataCy, isLargerText: isLargerText, label: label, toolTipText: toolTipText, type: type, value: value }) }) })));
};
export default FeaturedDataElement;
//# sourceMappingURL=FeaturedDataElement.js.map